import { render, staticRenderFns } from "./GTXBrain.vue?vue&type=template&id=b711da34&"
import script from "./GTXBrain.vue?vue&type=script&lang=js&"
export * from "./GTXBrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports